import React, { ButtonHTMLAttributes } from 'react';
import { ArrowLeftIcon, resetButtonStyle } from '@kvdbil/components';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';

const CloseIconBtn = styled.button`
  ${resetButtonStyle}
  font-size: 2rem;

  &:focus-visible {
    outline: revert;
  }
`;

export const GoBack = (props: ButtonHTMLAttributes<HTMLButtonElement>) => {
  const { t } = useTranslation();
  return (
    <CloseIconBtn aria-label={t('Go back')} type="button" {...props}>
      <ArrowLeftIcon />
    </CloseIconBtn>
  );
};
